<form [formGroup]="userForm" class="example-form objects-form mb-2" style="max-height: 30vh; overflow-y: auto;">

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.userForm.email' | translate}}</mat-label>
        <input formControlName="email" matInput type="text" required>
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.userForm.language' | translate }}</mat-label>
        <mat-select formControlName="language" name="language">
          <mat-option value="en"> {{'en' | translate }}</mat-option>
          <mat-option value="de"> {{'de' | translate }}</mat-option>
        </mat-select>
    </mat-form-field>

    <div class="w-100 roles-select-block">
        <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{'COCKPIT.SETTINGS.userRoles' | translate}}</mat-label>
            <mat-select [formControl]="rolesSelectCtrl" multiple>
                <mat-option *ngFor="let r of roleOptions; trackBy: trackByIdentifier" [value]="r.identifier">
                    {{ r.title }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <span class="text-muted small">{{'FORM.userForm.roleRecorder_info' | translate}}</span>
    </div>

</form>

<div class="w-100 additional-contexts-block" *ngIf="contextRows.length">
    <span class="text-muted text-uppercase">{{'FORM.userForm.contexts' | translate}}</span>
    <div class="context-row" *ngFor="let row of contextRows">
        <mat-checkbox [checked]="row.selected" (change)="toggleContext(row, $event.checked)">
            {{ row.name }}
        </mat-checkbox>
    </div>
    <span class="text-muted small" *ngIf="!hasSelectedContext">{{'FORM.userForm.select_at_least_one_context' | translate}}</span>
</div>

<div class="dialog-footer">
    <button class="second-btn" mat-button type="button" (click)="onCancle()">
        {{ 'cancel' | translate }}
    </button>

    <button [disabled]="userForm.invalid || !hasSelectedContext" class="first-btn" mat-button type="button" (click)="onSubmit()">
        {{ 'FORM.BTN_INVITE_USER' | translate }}
    </button>
</div>
